module.exports = __webpack_public_path__ + "static/icons/icon-ski-hire--red-98d63317687f3d6b47bc41e8a2a6f325.svg";